import styled from 'styled-components';

export const ReminderSelectContainer = styled.div`
  padding-top: 24px;
`;

export const TimezoneSelectContainer = styled.div`
  padding-top: 24px;
`;
